import { createSelector } from 'reselect';

import { __getCommonSettings, getValueOfCookie } from 'store/common/settings/selectors';
import { COOKIES_NAMES } from 'constants/cookies';

import { unpackCompareProductIds } from './helpers';

// export const getCompareCookieName = state => __getCommonSettings(state).compareCookieName;
export const getCompareUrl = (state) => __getCommonSettings(state).compareUrl;

export const getComparedProductIds = createSelector(
  getValueOfCookie(() => COOKIES_NAMES.COMPARISON_DEVICES),
  (packedList) => unpackCompareProductIds(packedList),
);
